import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { colors, gradients, radii, shadows } from '../theme/designTokens';

const FeedbackModal = ({
  open,
  onClose,
  type = 'success',
  title,
  message,
}) => {
  const isSuccess = type === 'success';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: radii.xl,
          overflow: 'hidden',
          boxShadow: shadows.lg,
        },
      }}
    >
      <Box
        sx={{
          background: isSuccess ? gradients.navy : 'linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%)',
          px: 3,
          py: 2.5,
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          aria-label="Close"
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'rgba(255,255,255,0.7)',
            '&:hover': { color: colors.white, background: 'rgba(255,255,255,0.1)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {isSuccess ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 36, color: colors.gold }} />
          ) : (
            <ErrorOutlineIcon sx={{ fontSize: 36, color: '#fecaca' }} />
          )}
          <Typography sx={{ color: colors.white, fontWeight: 700, fontSize: '1.15rem', pr: 4 }}>
            {title}
          </Typography>
        </Box>
      </Box>

      <DialogContent sx={{ px: 3, py: 3 }}>
        <Typography sx={{ color: colors.slate, fontSize: '0.95rem', lineHeight: 1.7, mb: 3 }}>
          {message}
        </Typography>
        <Button
          fullWidth
          onClick={onClose}
          sx={{
            py: 1.25,
            background: isSuccess ? gradients.gold : '#dc2626',
            color: isSuccess ? colors.navy : colors.white,
            fontWeight: 700,
            borderRadius: radii.pill,
            textTransform: 'none',
            fontSize: '1rem',
            boxShadow: isSuccess ? shadows.gold : 'none',
            '&:hover': {
              background: isSuccess ? colors.goldLight : '#b91c1c',
            },
          }}
        >
          OK
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackModal;
